(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-tag-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-tag-scroller')) {
    customElements.define('collection-tag-scroller', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.collection-tag-links__list');
        this.buttons = [...this.querySelectorAll('button')];
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          this.list.scrollBy({
            left: Number(button.dataset.direction) * this.list.clientWidth * 0.75,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }, options));
        this.list.addEventListener('scroll', () => this.updateButtons(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.updateButtons());
        this.observer.observe(this);
        this.observer.observe(this.list);
        [...this.list.children].forEach(item => this.observer.observe(item));
        this.updateButtons();
      }

      updateButtons() {
        const mobile = matchMedia('(max-width: 740px)').matches;
        const availableWidth = this.clientWidth;
        const overflow = mobile && this.list.scrollWidth > availableWidth + 1;
        this.buttons.forEach(button => { button.hidden = !overflow; });
        const maximum = this.list.scrollWidth - this.list.clientWidth;
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        const position = this.list.scrollLeft;
        this.buttons[0].disabled = rtl ? position <= -maximum + 1 : position <= 1;
        this.buttons[1].disabled = rtl ? position >= -1 : position >= maximum - 1;
      }

      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
